import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function Proof() {
  return <SectionWrapper data-id="element-169">
      <div className="bg-sage-light/50 p-8 md:p-12 rounded-3xl text-center border border-sage/20" data-id="element-170">
        <div className="flex justify-center mb-6" data-id="element-171">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-8 h-8 text-yellow-500 fill-current" viewBox="0 0 20 20" data-id="element-172">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-173" />
            </svg>)}
        </div>
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-6 leading-relaxed" data-id="element-174">
          "En solo 7 días, la mayoría de las mujeres reportan una reducción
          visible en la circunferencia abdominal y, lo más importante, el fin de
          la pesadez digestiva."
        </h3>
        <p className="text-lg text-gray-700 italic" data-id="element-175">
          No es magia, es lo que sucede cuando dejas de luchar contra tus
          hormonas y empiezas a alimentarlas.
        </p>
      </div>
    </SectionWrapper>;
}